import GreenBorderGradient from '../ui/green-border-gradient'

type FormInputProps = {
  error?: string
  apiError?: string
} & React.InputHTMLAttributes<HTMLInputElement>

export function FormInput({ error, apiError, ...props }: FormInputProps) {
  return (
    <div className="flex flex-col gap-[9px]">
      <div className="flex flex-col rounded-3xl bg-white/10 p-4 backdrop-blur-[50px]">
        <GreenBorderGradient className="rounded-3xl opacity-50" />
        <input
          className="font-hanken-grotesk w-full bg-transparent text-base font-medium tracking-[-0.011em] text-white outline-none placeholder:text-white/70"
          {...props}
        />
      </div>
      {error && <span className="text-sm text-red-500">{error}</span>}
      {apiError && <span className="text-sm text-red-500">{apiError}</span>}
    </div>
  )
}
